import { render, staticRenderFns } from "./goodsWaterfall.vue?vue&type=template&id=455731f4&scoped=true&"
import script from "./goodsWaterfall.vue?vue&type=script&lang=js&"
export * from "./goodsWaterfall.vue?vue&type=script&lang=js&"
import style0 from "./goodsWaterfall.vue?vue&type=style&index=0&id=455731f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455731f4",
  null
  
)

component.options.__file = "src/demo/packageMall/goodsWaterfall.vue"
export default component.exports